export default "__VITE_ASSET__BF7pJFou__"